<template>
    <div>
        <div
            class="push-notification-wrapper"
            :class="setup"
            v-show="setup === 'new'"
        >
            <div class="push-notification-container" v-show="popUpState">
                <div class="notification__close-icon" @click="closePopup()">
                    <icon-base height="24" width="24">
                        <icon-close></icon-close>
                    </icon-base>
                </div>
                <div class="notification__right-section">
                    <alert-bell-icon></alert-bell-icon>
                </div>
                <div class="notification__right-section">
                    <p class="notification__primary-text">
                        Never Miss An Update
                    </p>
                    <p class="notification__secondary-text">
                        Allow us to send you notifications.
                    </p>
                    <tq-button
                        :disabled="enablingNotification"
                        :loading="enablingNotification"
                        @click="enableNotification()"
                        type="primary"
                        class="primary-gradient"
                        >Okay</tq-button
                    >
                </div>
            </div>
        </div>
        <div
            class="push-notification-wrapper"
            :class="setup"
            v-show="setup === 'old'"
        >
            <div class="row">
                <div class="col-sm-6">
                    <p class="f-14 text-primary fw-600 mb-16">
                        Never Miss An Update
                    </p>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4">
                    <p class="f-14 fw-600 mb-16">
                        Allow us to send you notifications & alerts about your
                        fitness center
                    </p>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <button
                        :disabled="['granted'].indexOf(notificationAccess) > -1"
                        @click="enableNotification()"
                        type="button"
                        class="btn btn-secondary rolePermissionSettingsLoader"
                    >
                        Okay
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as firebase from "firebase/app";

import "firebase/messaging";
import TqButton from "./../components/basic/button";
import UINotification from "../services/notification";
import saveFCMToken from "../api/push-notification";
import IconClose from "../components/icon/navigation/IconClose.vue";
import IconBase from "../components/icon/IconBase.vue";
import AlertBellIcon from "../components/icon/push-notification/AlertBellIcon";

const jsFilePath =
    process.env.NODE_ENV === "development" ? "js" : "js-minified";

const FIREBASE_CONFIG = {
    apiKey: process.env.MIX_PUSH_NOTIFICATION_API_KEY,
    appId: process.env.MIX_PUSH_NOTIFICATION_APP_ID,
    authDomain: process.env.MIX_PUSH_NOTIFICATION_AUTH_DOMAIN,
    databaseURL: process.env.MIX_PUSH_NOTIFICATION_DATABASE_URL,
    measurementId: process.env.MIX_PUSH_NOTIFICATION_MEASUREMENT_ID,
    messagingSenderId: process.env.MIX_PUSH_NOTIFICATION_MESSAGING_SENDER_ID,
    projectId: process.env.MIX_PUSH_NOTIFICATION_PROJECT_ID,
    storageBucket: process.env.MIX_PUSH_NOTIFICATION_STORAGE_BUCKET,
};

const Notification = window.Notification;

const PERMISSION_ENUM = {
    GRANTED: "granted",
    DENIED: "denied",
    DEFAULT: "default",
};

const firebaseObj = firebase.initializeApp(FIREBASE_CONFIG);

let messaging, isFireBaseAPISupported;

try {
    messaging = firebaseObj.messaging();
    isFireBaseAPISupported = firebase.messaging.isSupported();
} catch (error) {
    console.log(error);
}

function checkUserClosedPopupBefore() {
    return window.localStorage.getItem("@traqade-push-popup") === "1";
}

function userClosedThePopup() {
    window.localStorage.setItem("@traqade-push-popup", "1");
}

export default {
    name: "push-notification",
    components: {
        TqButton,
        IconClose,
        IconBase,
        AlertBellIcon,
    },
    props: {
        setup: {
            type: String,
            default: "new",
        },
    },
    data() {
        return {
            notificationAccess: Notification.permission,
            enablingNotification: false,
            popUpState:
                [PERMISSION_ENUM.DEFAULT].indexOf(Notification.permission) >
                    -1 &&
                isFireBaseAPISupported &&
                !checkUserClosedPopupBefore(),
        };
    },
    mounted: function() {
        this.notificationAccess = Notification.permission;
        this.showNotificationEnableButton();
        if (messaging) {
            if ("serviceWorker" in navigator) {
                navigator.serviceWorker
                    .register(`/${jsFilePath}/firebase-messaging-sw.js`, {
                        updateViaCache: "none",
                    })
                    .then((registration) => {
                        console.log(registration);
                        registration.update();
                        messaging.useServiceWorker(registration);
                    })
                    .catch((error) => {
                        console.log("Service Worker Not Registered", error);
                    });
            }
            try {
                messaging.onTokenRefresh(() => {
                    messaging
                        .getToken()
                        .then((refreshedToken) => {
                            this.sendTokenToServer(refreshedToken);
                        })
                        .catch((err) => {
                            console.log(err.code);
                        });
                });
                messaging.onMessage((payload) => {
                    const { data } = payload;
                    const {
                        title,
                        body,
                        icon,
                        image,
                        click_action,
                        centerCode,
                    } = data;
                    const note = new Notification(title, {
                        body,
                        icon,
                        image,
                    });

                    const redirectUrl = `/center/${centerCode}?redirectTo=${click_action}`;

                    note.onclick = function(event) {
                        window.open(redirectUrl);
                        note.close();
                    };
                });
            } catch (error) {
                console.log(error);
            }
        }
    },
    methods: {
        closePopup: function() {
            this.popUpState = false;
            userClosedThePopup();
        },
        showNotificationEnableButton: function() {
            this.popUpState =
                [PERMISSION_ENUM.DEFAULT].indexOf(this.notificationAccess) >
                    -1 &&
                isFireBaseAPISupported &&
                !checkUserClosedPopupBefore();
        },
        sendTokenToServer: async function(token) {
            const response = await saveFCMToken({
                token,
            });
            this.enablingNotification = false;
            this.notificationAccess = Notification.permission;
            this.popUpState = false;
        },

        getPermissionAndToken: function() {
            if (messaging) {
                try {
                    this.enablingNotification = true;
                    messaging
                        .getToken()
                        .then((currentToken) => {
                            if (currentToken) {
                                console.log(currentToken);
                                this.sendTokenToServer(currentToken);
                            } else {
                                console.log(
                                    "No Instance ID token available. Request permission to generate one."
                                );
                                this.enablingNotification = true;
                            }
                        })
                        .catch((err) => {
                            console.log(
                                "An error occurred while retrieving token. ",
                                err
                            );
                            console.log(err.code);
                            this.enablingNotification = true;
                        });
                } catch (error) {
                    console.log("error");
                }
            }
        },

        enableNotification: function() {
            if (Notification) {
                Notification.requestPermission().then((permission) => {
                    if (permission === PERMISSION_ENUM.GRANTED) {
                        this.notificationAccess = PERMISSION_ENUM.GRANTED;
                        this.getPermissionAndToken();
                    } else {
                        console.log("permission denied");
                    }
                });
            } else {
                console.log("PUSH NOTIFICATION NOT SUPPORTED");
            }
        },
    },
};
</script>

<style lang="scss">
.push-notification-wrapper {
    &.new {
        position: fixed;
        top: 12px;
        right: 16px;
        z-index: 2000;
        .push-notification-container {
            position: relative;
            width: 480px;
            box-shadow: 0 2px 6px 0 #eaedf3;
            background-color: #ffffff;
            padding: 24px;
            display: flex;
            .notification__close-icon {
                position: absolute;
                top: 24px;
                right: 24px;
                color: #3e3f42;
                cursor: pointer;
            }
            .notification__right-section {
                margin-right: 24px;
            }
            .notification__right-section {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                .notification__primary-text {
                    font-size: 18px;
                    font-weight: 600;
                    font-stretch: normal;
                    font-style: normal;
                    letter-spacing: 0.1px;
                    color: #3e3f42;
                    margin-bottom: 8px;
                }
                .notification__secondary-text {
                    font-size: 14px;
                    font-weight: 500;
                    font-stretch: normal;
                    font-style: normal;
                    letter-spacing: normal;
                    color: rgba(62, 63, 66, 0.75);
                    margin-bottom: 16px;
                }
            }
        }
    }
}
</style>
